import { render, staticRenderFns } from "./JAreaLinkage.vue?vue&type=template&id=1dc85875&scoped=true&"
import script from "./JAreaLinkage.vue?vue&type=script&lang=js&"
export * from "./JAreaLinkage.vue?vue&type=script&lang=js&"
import style0 from "./JAreaLinkage.vue?vue&type=style&index=0&id=1dc85875&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc85875",
  null
  
)

export default component.exports